export class WorkstationLine {
  id: number;
  entdata_id: number;
  workstation_id: number;
  workstation: any;
  minutes: number;
  created_at: Date;
  updated_at: Date;
}
